const snakeCaseToTitleCase = (str: string) => {
    const frags = str.split('_');
    for (let i = 0; i < frags.length; i += 1) {
        frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
    }
    return frags.join(' ');
};

const getQualificationClassName = (str: string) => str.split('_').pop();

export { snakeCaseToTitleCase, getQualificationClassName };